<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <ClientColsDialog ref="colsDialog" />

          <OLoadingDialog :value="isLoading"/>

          <v-card>
            <v-toolbar class="card-bar">
              <v-toolbar-title>Módulos</v-toolbar-title>

              <span class="mx-3">
                <v-btn icon @click="reload">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </span>

              <span class="mr-3">
                <v-btn icon @click="openVarsDialog()">
                  <v-icon>visibility</v-icon>
                </v-btn>
              </span>

              <v-spacer/>

              <v-text-field ref="txtKeywords"
                v-model="keywords" class="pa-0"
                append-icon="search"
                label="Filtro por palavras-chave"
                @keyup.enter="$mergeQs({keywords: keywords})"
                single-line hide-details/>

              <v-menu v-model="menu"
                :close-on-content-click="false"
                :max-width="400"
                :min-width="400"
                offset-y left>

                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>arrow_drop_down</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-card-text class="pa-6 caption">
                    <span class="od-info"/>
                    Use <code>ids:1,2,3</code> para ver apenas estes módulos.
                  </v-card-text>
                  <v-divider/>
                  <v-card-text class="pa-3">

                    <div class="pa-3">
                      <v-switch v-model="hideOrgNone"
                        label="Ocultar módulos não concedidos"
                        single-line hide-details/>
                    </div>

                    <div class="pa-3">
                      <v-switch v-model="showOnlyPaused"
                        label="Apenas pausados/ignorados"
                        single-line hide-details/>
                    </div>

                    <div class="pa-3">
                      <v-select v-model="depotId"
                        clearable hide-details
                        label="Estoque atual"
                        :items="allDepots"
                        item-value="id"
                        item-text="name"/>
                    </div>

                    <div class="pa-3">
                      <v-select v-model="fwVersion"
                        clearable hide-details
                        label="Firmware atual"
                        :items="allFws"
                        item-value="version"
                        item-text="name"/>
                    </div>

                    <div class="pa-3">
                      <v-select v-model="orgId"
                        clearable hide-details
                        label="Organização"
                        :items="allPrdOrgs"
                        item-value="id"
                        item-text="label"/>
                    </div>

                  </v-card-text>
                </v-card>
              </v-menu>

              <v-spacer/>

              <v-btn color="primary"
                @click="newClient">
                Novo Módulo...
              </v-btn>
            </v-toolbar>

            <ODataTable
              :spec="spec"
              :items="filteredRows"
              @rowClicked="go"/>

          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import {Client, Depot, Firmware, Org} from '@/models'
import {fullSpec} from './client-columns'
import {selectCols} from 'oderon-commons/src/tables'
import {strings, isBlank, hasTag} from 'oderon-commons/src/utils'

const defCols = ['id', 'clientIndicators', 'org',
  'orgIndicators', 'vehicleCode', 'fw',
  'batchNumber', 'comments']

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    ClientColsDialog: require('./ClientColsDialog').default,
  },
  data() {
    return {
      isLoading: false,
      menu: false,
      keywords: this.$route.query.keywords,
      depotId: null,
      fwVersion: null,
      orgId: null,
      hideOrgNone: true,
      showOnlyPaused: false,
      rows: [],
      allDepots: [],
      allFws: [],
      allOrgs: [],
      showingVarsDialog: false
    }
  },
  computed: {
    qs()            { return this.$route.query },
    selectedCols()  { return strings(this.qs.cols || defCols) },
    qsKeywords()    { return this.qs.keywords },
    spec()          { return selectCols(fullSpec, this.selectedCols) },
    apiWhere()      {
      let where = {keywords: this.qsKeywords}
      if ( _.some(this.spec.columns, {needsHealth:true}) ) {
        where.includeHealth = true
      }

      where.currentDepotId = this.depotId
      where.currentFirmwareVersion = this.fwVersion

      return where
    },
    filteredRows() {
      return _.reject(this.rows, r => {
        if ( this.hideOrgNone && r.organizationId == -1 ) return true
        if ( this.showOnlyPaused && !isPaused(r) ) return true

        if ( _.isFinite(this.orgId) &&
             r.organizationId != this.orgId ) return true

        if ( _.isFinite(this.fwVersion) &&
             r.currentFirmwareVersion != this.fwVersion ) return true

        return false
      })
    },

    allPrdOrgs() {
      return _.chain(this.allOrgs).filter(o => {
        return hasTag(o.extraInfo, 'prd')
      }).sortBy('label').value()
    }
  },
  watch: { apiWhere() { this.reload() } },
  mounted() { this.reload() },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
      setTimeout(() => this.$refs.txtKeywords.focus(), 100)
    },
    async fetchData() {
      this.rows = await Client.findAll(this.apiWhere)
      this.allDepots = await Depot.findAll()
      this.allFws = _.sortBy(await Firmware.findAll(), 'version').reverse()
      this.allOrgs = await Org.findAll()
    },

    go(row, idx, evt) {
      if ( evt && (evt.ctrlKey || evt.button == 1) ) {
        window.open(`/#/clients/${row.id}`, '_blank')
      } else {
        this.$router.push(`/clients/${row.id}`)
      }
    },

    async openVarsDialog() {
      let dialog = this.$refs.colsDialog,
          res = await dialog.open(this.selectedCols)

      if ( res == null ) return
      this.$mergeQs({cols: res})
    },

    async newClient() {
      let cid = await this.$prompt({
        label: 'Informe o ID do novo módulo:'
      })

      if ( !isBlank(cid) ) {
        this.$loading(async () => {
          await Client.save({id: +cid})
          this.$router.push(`/clients/${cid}`)
        })
      }
    }
  }
}

function isPaused(r) {
  if ( r == null ) return false
  if ( r.isIgnored || r.isPaused ) return true
  if ( isPaused(r.organization) ) return true
  return false
}
</script>

<style>
</style>
